import IOtherCompanyConstructionOutput from "../IOtherCompanyConstructionOutput";

export default function createOtherCompanyConstructionOutput(): IOtherCompanyConstructionOutput {
  return {
    id: "",
    serviceTaskTypeId: 0,
    name: "",
    shortName: "",
    mConstructionId: 0
  };
}
